import { useEffect, useState } from 'react'
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { KeyRound, Check, AlertCircle } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { testEnvAPI } from '@/lib/api'

/* /inloggen-als/<token>?redirect=/pad
   Wisselt de eenmalige token in en logt deze sessie in als de doelgebruiker.
   Bedoeld om in een tweede tab of op een tweede scherm te openen — de token
   werkt maar één keer, dus je bestaande sessie blijft veilig staan waar hij is. */
export default function GhostLoginPage() {
  const { token } = useParams()
  const [zoek] = useSearchParams()
  const navigate = useNavigate()
  const bestemming = zoek.get('redirect') || '/'

  const [status, setStatus] = useState('bezig')  // bezig | ok | fout
  const [fout, setFout]     = useState(null)
  const [user, setUser]     = useState(null)

  useEffect(() => {
    let opruimen = false
    testEnvAPI.gebruikGhost(token)
      .then(({ data }) => {
        if (opruimen) return
        // Deze sessie wordt de nieuwe gebruiker; bewaar in dezelfde vorm als login.
        localStorage.setItem('auth_token', data.token)
        localStorage.setItem('user', JSON.stringify(data.user))
        setUser(data.user)
        setStatus('ok')
        setTimeout(() => navigate(bestemming, { replace: true }), 1200)
      })
      .catch(e => {
        if (opruimen) return
        setFout(e.response?.data?.error ?? e.message)
        setStatus('fout')
      })
    return () => { opruimen = true }
  }, [token, bestemming, navigate])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-md" style={{ borderLeft: '2px solid rgb(var(--acid-rgb))' }}>
        <CardContent className="p-6">
          <div className="flex items-center gap-3 mb-3">
            <KeyRound className="h-6 w-6 text-acid" />
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              Ghost-login voor tests
            </span>
          </div>

          {status === 'bezig' && (
            <p className="text-sm text-muted-foreground">Token controleren…</p>
          )}

          {status === 'ok' && (
            <>
              <div className="flex items-center gap-2 text-live mb-2">
                <Check className="h-4 w-4" />
                <span className="font-semibold text-sm">Ingelogd als {user?.display_name || user?.username}</span>
              </div>
              <p className="text-xs text-muted-foreground">
                Rol: {user?.role}. Je springt zo naar {bestemming}.
              </p>
            </>
          )}

          {status === 'fout' && (
            <div className="flex items-start gap-2 text-signal">
              <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" />
              <div>
                <div className="font-semibold text-sm">Werkt niet</div>
                <div className="text-xs text-muted-foreground">{fout}</div>
                <p className="text-xs text-muted-foreground mt-2">
                  Vraag een nieuwe ghost-token aan vanuit de testhub. Elk token werkt maar één keer.
                </p>
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
